import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/jobsearch/icon-sort.svg'
import _imports_1 from '@/assets/img/jobsearch/icon-no-result.svg'
import _imports_2 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-435f9112"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-apply-index" }
const _hoisted_4 = { class: "p-apply-index-container" }
const _hoisted_5 = {
  key: 0,
  class: "p-apply-index-wp"
}
const _hoisted_6 = {
  key: 1,
  class: "p-apply-index-pageLink"
}
const _hoisted_7 = { class: "p-jobsearch-control_buttons" }
const _hoisted_8 = {
  class: "p-jobsearch-control_buttons_sort js-jobsearch-select",
  "data-select": "sort"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-jobsearch-control_buttons_sort_icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "js-jobsearch-select_label" }
const _hoisted_11 = { class: "p-jobsearch-control_buttons_sort_list_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sort1" }, "更新日時昇順", -1))
const _hoisted_13 = { class: "p-jobsearch-control_buttons_sort_list_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sort2" }, "更新日時降順", -1))
const _hoisted_15 = {
  key: 2,
  class: "p-apply-index-list"
}
const _hoisted_16 = { class: "p-apply-index-list_no-result" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-index-list_no-result_heading" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "p-apply-index-list_no-result_img",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "選考中の求人がありません")
], -1))
const _hoisted_18 = { class: "p-apply-index-list_no-result_contents" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("担当者が紹介する求人以外でも、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ご自身で希望の求人を探すことができます。")
], -1))
const _hoisted_20 = {
  key: 3,
  class: "p-apply-index-list"
}
const _hoisted_21 = { class: "p-jobsearch-list_more" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "l-wrapper_nav" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]

import { countCloseApplyProgressService, getApplyListService } from '@/api/services/shintyokuService';
import ApplyListItem from '@/components/ApplyListItem.vue';
import ApplyWidget from '@/components/ApplyWidget.vue';
import Loading from '@/components/Loading.vue';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { Apply } from '@/types';
import { TrnShintyokuSelectRequest } from '@/types/request';
import { onDeactivated, ref, watch } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { domHelperUtils } from '@/utils/domHelper';
import { onActivated } from 'vue';
import { milliseconds } from 'date-fns';
import { useStore } from 'vuex';
// 選考リストのダミーデータ

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyView',
  setup(__props) {

const applyList = ref<Array<Apply>>([]);
const totalCount = ref(0);
const isLoading = ref(true);
const isLoadingMore = ref(false);
const applyWidgetRef = ref<InstanceType<typeof ApplyWidget> | null>(null);
const isDisableCloseList = ref(true);
const isJobListLoaded = ref(false);

const hasMore = ref(false);
const sortState = ref({
  isOpen: false,
  selectedText: '更新日時降順',
  selectedValue: 'desc',
});
const shintyokuSelectParams = ref<TrnShintyokuSelectRequest>({});

const route = useRoute();
const router = useRouter();

async function loadApplyList(params?: TrnShintyokuSelectRequest, isLoadMore = false) {
  try {
    const requestParams: TrnShintyokuSelectRequest = {
      ...shintyokuSelectParams.value,
      ...(params || {}),
    };

    const applyData = await getApplyListService(requestParams);
    const fetchedJobs = applyData.shintyokuList;
    if (fetchedJobs && fetchedJobs.length > 0) {
      if (!isLoadMore) {
        applyList.value = fetchedJobs;
      } else {
        applyList.value = [...applyList.value, ...fetchedJobs];
      }
    }
    totalCount.value = applyData.totalCount;
    shintyokuSelectParams.value.pageCursor = applyData.pageCursor;
    hasMore.value = applyData.hasMore;
    isJobListLoaded.value = true;
  } catch (error) {
    console.error(error);
  }
}

async function sortApplyList(sortVal: string) {
  isLoading.value = true;
  if (sortVal == 'asc') {
    sortState.value.selectedText = '更新日時昇順';
  } else {
    sortState.value.selectedText = '更新日時降順';
  }
  sortState.value.selectedValue = sortVal;
  sortState.value.isOpen = false;
  shintyokuSelectParams.value.pageCursor = {};

  shintyokuSelectParams.value.orderBy = sortState.value.selectedValue;
  await loadApplyList({});
  isLoading.value = false;
  // save current params to session
  sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.APPLY_SORT, JSON.stringify(sortState.value));
}

async function nextPage() {
  if (applyList.value.length < totalCount.value) {
    isLoadingMore.value = true;
    await loadApplyList({}, true);
    isLoadingMore.value = false;
  }
}

const handleOutsideDropdownClick = (event: MouseEvent) => {
  const selectContainer = document.querySelector('.js-jobsearch-select');
  if (!selectContainer) return;
  if (!selectContainer.contains(event.target as Node) && sortState.value.isOpen) {
    sortState.value.isOpen = false;
  }
};

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

watch(() =>route.query.k, async (newValue) => {
  if((route.meta.isBack && isJobListLoaded.value) || route.name != 'n00') {
    return;
  }

  if (isLoading.value) return;
  if(newValue) {
    shintyokuSelectParams.value.countApplyType = newValue?.toString();
  } else {
    delete shintyokuSelectParams.value.countApplyType;
  }
  isLoading.value = true;
  shintyokuSelectParams.value.pageCursor = {};
  await loadApplyList();
  await applyWidgetRef.value?.loadApplyCountData();
  isLoading.value = false;
});

const store = useStore();
onActivated(async () => {
  isLoading.value = true;
  document.addEventListener('click', handleOutsideDropdownClick);

  // Keep the page state when has back event
  if(route.meta.isBack && isJobListLoaded.value) {
    isLoading.value = false;
    await store.dispatch('favorites/clearFavorite');
    return;
  }

  // Reset ref before set new value
  resetRefs();

  if (route.query.k){
    // validate params
    const keys = applyWidgetRef.value?.applyStatistics.map(k => k.query);
    if (keys && keys.indexOf(route.query.k.toString()) >= 0) {
      shintyokuSelectParams.value.countApplyType = route.query.k.toString();
    } else {
      router.replace({ query: {} });
    }
  }

  const sort = JSON.parse(sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.APPLY_SORT) || 'false');
  if (sort) {
    sortState.value = {...sort, isOpen: false};
    shintyokuSelectParams.value.page = 1;
    shintyokuSelectParams.value.orderBy = sortState.value.selectedValue;
  }

  const countCloseList = await countCloseApplyProgressService();
  isDisableCloseList.value = (countCloseList == 0);
  await loadApplyList();
  isLoading.value = false;
  document.addEventListener('click', handleOutsideDropdownClick);
});

onDeactivated(() => {
  document.removeEventListener('click', handleOutsideDropdownClick);
});

const resetRefs = () => {
  sortState.value = {
    isOpen: false,
    selectedText: '更新日時降順',
    selectedValue: 'desc',
  };
  shintyokuSelectParams.value = {};
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", null, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createVNode(ApplyWidget, {
                  ref_key: "applyWidgetRef",
                  ref: applyWidgetRef,
                  "class-prefix": "p-apply-index",
                  isFromApply: true,
                  isJobListLoaded: isJobListLoaded.value
                }, null, 8, ["isJobListLoaded"])
              ], 512), [
                [_vShow, !isLoading.value]
              ]),
              (!isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (!isDisableCloseList.value)
                      ? (_openBlock(), _createBlock(_unref(RouterLink), {
                          key: 0,
                          class: "p-apply-index-pageLink",
                          to: { name: 'n01' }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("選考終了")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, "選考終了")),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "p-jobsearch-control_buttons_sort_btn js-jobsearch-select_btn",
                          onClick: _cache[0] || (_cache[0] = () => sortState.value.isOpen = !sortState.value.isOpen)
                        }, [
                          _hoisted_9,
                          _createElementVNode("span", _hoisted_10, _toDisplayString(sortState.value.selectedText), 1)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["p-jobsearch-control_buttons_sort_list js-jobsearch-select_list", { __opened: sortState.value.isOpen }])
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("input", {
                              type: "radio",
                              name: "sort",
                              id: "sort1",
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (sortApplyList('asc')))
                            }, null, 32)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("input", {
                              type: "radio",
                              name: "sort",
                              id: "sort2",
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (sortApplyList('desc')))
                            }, null, 32)
                          ])
                        ], 2)
                      ])
                    ]),
                    (applyList.value.length == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createVNode(_unref(RouterLink), {
                                class: "p-apply-index-list_no-result_btn",
                                to: { name: 'h01' }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("他の求人を探す")
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (applyList.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createTextVNode(" ※1年以内の応募求人を表示しています "),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applyList.value, (apply) => {
                            return (_openBlock(), _createBlock(ApplyListItem, {
                              key: apply.orderId,
                              apply: apply
                            }, null, 8, ["apply"]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_21, [
                            (applyList.value.length < totalCount.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "p-jobsearch-btn __blue __more",
                                  disabled: isLoadingMore.value,
                                  onClick: nextPage
                                }, [
                                  _createTextVNode(" 検索結果をもっと見る"),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["p-jobsearch-btn_ico", { 'loading-spinner': isLoadingMore.value }])
                                  }, null, 2)
                                ], 8, _hoisted_22))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_23, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          onClick: _withModifiers(scrollToTop, ["prevent"]),
          "aria-label": "ページトップへ戻る"
        }, _hoisted_26, 8, _hoisted_24)
      ], 512), [
        [_vShow, !isLoading.value]
      ])
    ]),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ], 64))
}
}

})